import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import {
  setLoadingTaxCodes,
  setLoadingTaxCode,
  setLoadingTaxCodeCreate,
  setLoadingTaxCodeUpdate,
  setLoadingTaxCodeDelete,
  setErrorLoadingTaxCodes,
  setErrorLoadingTaxCode,
  setErrorCreatingTaxCode,
  setErrorUpdatingTaxCode,
  setErrorDeletingTaxCode,
  setTaxCodes,
  setTaxCode,
  createTaxCodeSuccess,
  updateTaxCodeSuccess,
  deleteTaxCodeSuccess,
  setServerResponseStatus,
} from "../slices/taxCode";
import { getErrorMessage } from "../../utils/errorUtils";

export const getTaxCodes = () => async (dispatch) => {
  dispatch(setLoadingTaxCodes());

  try {
    const { data } = await axiosInstance.get("/tax-codes", {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      dispatch(setTaxCodes(data.data));
    }
  } catch (error) {
    dispatch(setErrorLoadingTaxCodes(getErrorMessage(error)));
  }
};

export const getTaxCodeById = (id) => async (dispatch) => {
  dispatch(setLoadingTaxCode());

  try {
    const { data } = await axiosInstance.get(`/tax-codes/${id}`, {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      dispatch(setTaxCode(data.data));
    }
  } catch (error) {
    dispatch(setErrorLoadingTaxCode(getErrorMessage(error)));
  }
};

export const createTaxCode = (values) => async (dispatch) => {
  dispatch(setLoadingTaxCodeCreate());

  try {
    const { data } = await axiosInstance.post("/tax-codes", values, {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      toast.success(data.message || "TaxCode created successfully!");
      dispatch(createTaxCodeSuccess(data.data));
      dispatch(
        setServerResponseStatus({
          operation: "create",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const message = getErrorMessage(error);
    toast.error(message);
    dispatch(setErrorCreatingTaxCode(message));
  }
};

export const updateTaxCode =
  ({ id, values }) =>
  async (dispatch) => {
    dispatch(setLoadingTaxCodeUpdate());

    try {
      const { data } = await axiosInstance.put(`/tax-codes/${id}`, values, {
        headers: { requiresAuth: true },
      });

      if (data.status === "SUCCESS") {
        toast.success(data.message || "TaxCode updated successfully!");
        dispatch(updateTaxCodeSuccess(data.data));
        dispatch(
          setServerResponseStatus({
            operation: "update",
            status: data.statusCode,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(setErrorUpdatingTaxCode(message));
    }
  };

export const deleteTaxCode = (id) => async (dispatch) => {
  dispatch(setLoadingTaxCodeDelete());

  try {
    const { data } = await axiosInstance.delete(`/tax-codes/${id}`, {
      headers: { requiresAuth: true },
    });

    if (data.status === "SUCCESS") {
      toast.success(data.message || "TaxCode deleted successfully!");
      dispatch(deleteTaxCodeSuccess(id));
      dispatch(
        setServerResponseStatus({
          operation: "delete",
          status: data.statusCode,
        }),
      );
    }
  } catch (error) {
    const message = getErrorMessage(error);
    toast.error(message);
    dispatch(setErrorDeletingTaxCode(message));
  }
};

export const resetTaxCodeServerStatus = () => (dispatch) => {
  dispatch(setServerResponseStatus(null));
};
